const ContributorStatus = {
  INVITED: 'Invited',
  CONTRIBUTED: 'Contributed',
  LOCKED: 'Locked',
  DELETED: 'Deleted'
};

export { ContributorStatus };
